import PropTypes from "prop-types"
import React, { useState } from "react"

const SignatureSection = ({ status, signaturePath, copy }) => {
  const [imageFailed, setImageFailed] = useState(false)

  if (status !== "signed") {
    return (
      <div className="flex flex-col items-center justify-center space-y-2 rounded-lg border border-gray-300 py-10">
        <i className="fa-solid fa-spinner-third fa-spin text-2xl text-gray-400" />
        <span className="text-gray-700">{copy.confirming}</span>
      </div>
    )
  }

  if (imageFailed) {
    return (
      <div className="flex items-center justify-center rounded-lg border border-gray-300 py-10 text-gray-700">
        {copy.signatureUnavailable}
      </div>
    )
  }

  return (
    <div className="flex h-32 items-center justify-center rounded-lg border border-gray-300 p-6">
      <img
        src={signaturePath}
        alt={copy.signature}
        className="max-h-full max-w-full object-contain"
        onError={() => setImageFailed(true)}
      />
    </div>
  )
}

SignatureSection.propTypes = {
  status: PropTypes.oneOf(["awaiting_signature", "signed"]).isRequired,
  signaturePath: PropTypes.string,
  copy: PropTypes.shape({
    confirming: PropTypes.string.isRequired,
    signature: PropTypes.string.isRequired,
    signatureUnavailable: PropTypes.string.isRequired,
  }).isRequired,
}

export default SignatureSection
